export enum SubmissionStatusEnum {
	readyForApproval = 'Ready for Approval',
	submissionApproved = 'Submission Approved',
	submissionRejected = 'Submission Rejected',
	submissionInProcess = 'Submission In Process',
	submissionFailed = 'Submission Failed',
  pendingModelRegistration = 'Pending Model Registration',
  replaced = 'Replaced',
  haSystemError = 'HA System Error',
  invalidCredentials = 'Invalid Credentials',
  internalSystemError = 'Internal System Error',
  submissionPassed = 'Submission Passed',
  hungRecord = 'Hung Record'
}
